import React from "react";

import House from "./house";

const Houses = ({ houses }) => {
	return (
		<div className="step">
			{houses.map((houseObj) => {
				return (
					<House
						key={houseObj.houseId}
						house={houseObj}
					/>
				);
			})}
		</div>
	);
};

export default Houses;
